import { useEffect, useState, useCallback } from "react";
import { Button } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { apiPost } from "api/callApi";
import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { removeCartSuccess } from "@store/cart/slice";
import { showAlert } from "utils/helper";

const CartOldFiles = (props) => {
  const { openView, setOpenView, setSelectedItems, cartCount = 0 } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const dispatch = useDispatch();

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || [],
  );
  const effectiveProjectId = currentProject?.id || projectId;

  const getOlderFileIds = useCallback(
    () => [...new Set((data || []).map((item) => item.fileId).filter(Boolean))],
    [data],
  );

  const handleLastSeen = useCallback(async () => {
    if (!effectiveProjectId) return;
    try {
      await apiPost(`/v1/cartlastseen/${effectiveProjectId}`);
    } catch (error) {
      console.log("Error", error);
    }
  }, [effectiveProjectId]);

  const handleCartData = useCallback(async () => {
    if (!effectiveProjectId) return;

    // No files in cart => don't show older files modal
    if (cartCount === 0) {
      setData([]);
      setOpenView(false);
      return;
    }

    try {
      const response = await apiPost(
        `/v1/cartolderfiles/${effectiveProjectId}`,
      );
      const oldFiles = response.data || [];
      console.log(
        "CartOldFiles - fetched oldFiles:",
        oldFiles,
        "count:",
        oldFiles.length,
        "cartCount:",
        cartCount,
      );
      setData(oldFiles);
      if (oldFiles.length === 0) {
        setOpenView(false);
        await handleLastSeen();
      } else {
        setOpenView(true);
      }
    } catch (error) {
      console.log("Error", error);
      setOpenView(false);
    }
  }, [effectiveProjectId, handleLastSeen, setOpenView]);

  useEffect(() => {
    handleCartData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleCartData, cartCount]);

  const handleCancelCompanyModal = useCallback(async () => {
    setOpenView(false);
    await handleLastSeen();
  }, [handleLastSeen, setOpenView]);

  const handleDeleteOlderCart = useCallback(async () => {
    const fileIds = getOlderFileIds();
    if (!effectiveProjectId || fileIds.length === 0) {
      setOpenView(false);
      await handleLastSeen();
      return;
    }

    const willDelete = await showAlert({
      title: "Are you sure?",
      text: "Are you sure you want to remove older files?",
      icon: "warning",
      dangerMode: true,
      buttons: true,
    });

    if (!willDelete) return;

    try {
      setLoading(true);
      const response = await apiPost(`/v1/cart/remove/`, {
        projectId: effectiveProjectId,
        files: fileIds,
        deleteOlder: 1,
      });
      dispatch(removeCartSuccess({ files: fileIds, deleteOlder: 1 }));
      setOpenView(false);
      await handleLastSeen();
      showAlert({ title: "Success", text: response?.message, icon: "success" });
    } catch (error) {
      console.log("Remove older cart files failed", error);
      showAlert({
        title: "Error",
        text: error?.response?.data?.message || "Failed to remove older files.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  }, [
    dispatch,
    effectiveProjectId,
    getOlderFileIds,
    handleLastSeen,
    setOpenView,
  ]);

  const handleMarkOlderfiles = useCallback(async () => {
    const fileIds = getOlderFileIds();
    setSelectedItems(fileIds);
    setOpenView(false);
    await handleLastSeen();
  }, [getOlderFileIds, handleLastSeen, setOpenView, setSelectedItems]);

  const RenderModalData = () => (
    <div>
      <div style={{ marginTop: "30px", textAlign: "center" }}>
        <p>
          {`There is ${data?.length} older files in the cart. What would you like to do?`}
        </p>
      </div>
      <div
        style={{
          display: "flex",
          gap: "10px",
          margin: "40px 20px 0px 20px",
          justifyContent: "center",
        }}
      >
        <Button
          caption="Nothing"
          onClick={handleCancelCompanyModal}
          fontSize="12px"
          color="white"
          style={{
            marginBottom: 8,
            background: theme.gradient.themeGradient,
            color: theme.colors.white,
            minWidth: "90px",
            borderRadius: "3px",
            height: "30px",
            fontSize: "12px",
          }}
        />

        <Button
          caption={"Remove all the old files"}
          isLoading={loading}
          color="white"
          fontSize="12px"
          style={{
            marginBottom: 8,
            background: theme.gradient.themeGradient,
            color: theme.colors.white,
            minWidth: "90px",
            height: "30px",
            borderRadius: "3px",
          }}
          onClick={handleDeleteOlderCart}
        />
        <Button
          caption={"Mark all the older files"}
          isLoading={loading}
          color="white"
          fontSize="12px"
          style={{
            marginBottom: 8,
            background: theme.gradient.themeGradient,
            color: theme.colors.white,
            minWidth: "90px",
            height: "30px",
            borderRadius: "3px",
          }}
          onClick={handleMarkOlderfiles}
        />
      </div>
    </div>
  );

  return (
    <>
      {openView && (
        <BulkActionView
          title={"Note!"}
          openModal={openView}
          renderBodyConditionally={RenderModalData}
          handleCloseModal={handleCancelCompanyModal}
          closeIcon={true}
        />
      )}
    </>
  );
};

export default CartOldFiles;
